
import { defineComponent } from 'vue';

import Loader from '@/components/LoadingAnimation.vue';
import { getDoctorsListBasedOnDepartment } from '@/graphql';
import { useQuery } from '@/hooks';
import { GRAPHQL_QUERYING_HOSPITAL_NAMES } from '@/ts/enum';

interface DoctorListTemplateDataInterface {
  loading: boolean;
  doctorsList: DoctoresListTypeForDepartment[];
}

interface DoctoresListTypeForDepartment {
  name: string;
  email: string;
  centerOfExcellence: string;
  profilePic: {
    url: string;
  };
  sys: {
    id: string;
  };
}

export default defineComponent({
  data(): DoctorListTemplateDataInterface {
    return {
      loading: true,
      doctorsList: [],
    };
  },
  components: { Loader },

  props: {
    name: {
      type: String,
      required: true,
    },
    teamName: {
      type: String,
      required: true,
    },

    queryName: {
      type: String,
      required: true,
    },
  },

  mounted() {
    (async () => {
      try {
        if (!this.queryName) {
          this.loading = false;
          return;
        }

        const { data } = await useQuery(getDoctorsListBasedOnDepartment, {
          hospital:
            GRAPHQL_QUERYING_HOSPITAL_NAMES.PROVIDENCE_HOSPITAL_ALAPPUZHA,
          department: this.queryName,
          limit: 10,
          skip: 0,
        });

        const items =
          data?.doctorsListingForParticularDepartmentCollection?.items || [];

        if (items.length && items[0].doctorCollection?.items?.length) {
          this.doctorsList = items[0].doctorCollection
            .items as DoctoresListTypeForDepartment[];
        } else {
          this.doctorsList = [];
        }
      } catch (e) {
        this.doctorsList = [];
      } finally {
        this.loading = false;
      }
    })();
  },
});
